import React from "react";
import PropTypes from "prop-types";
import Int from "./Int";
import Select from "./Select";
import Euro from "./Euro";
import DDMMYYYY from "./DDMMYYYY";
import Address from "./Address";
import TextLine from "./TextLine" ;
import TextArea from "./TextArea";
import Countries from "./Countries";
import Phone from "./Phone";
import Float from "./Float";
import Year from "./Year";
import AgeArray from "./AgeArray";
import MMYYYY from "./MMYYYY";
import {FloatingLabel} from "react-bootstrap";
import MultipleChoice from "./MultipleChoice";


export default function SmartInput(props) {
    function setAnswer(value) {
        const failure = isInvalid(value)
        //console.log('failed: ', failure)
        if (!failure) {
            props.setGroupState('valid')
            props.saveAnswer(value)
        } else {
            props.setGroupState('invalid')
            props.setHelperText(failure)
        }
    }
    function isInvalid(value) {
        //console.log(value)
        let invalid = false
        if (typeof props.answer?.validation === "function"){
            invalid = props.answer.validation(value)
        }

            //console.log('***')
            if (!invalid && props.answer?.validation?.min) {

                if (["ddmmyyyy", "mmyyyy"].includes(props.answer.type)) {
                    let dV = new Date(value)
                    let dM = props.answer.validation.min.value
                    //console.log(dV, dM)
                    if (dV.getTime() < dM.getTime()) {
                        invalid = props.answer.validation.min.message
                    }
                } else {
                   // console.log(value)
                    if (value < props.answer.validation.min.value) {
                        invalid = props.answer.validation.min.message
                    }
                }
            }

            if (!invalid && props.answer?.validation?.max) {
                if (["ddmmyyyy", "mmyyyy"].includes(props.answer.type)) {
                    let dV = new Date(value)
                    let dM = props.answer.validation.max.value
                    if (dV.getTime() > dM.getTime()) {
                        invalid = props.answer.validation.max.message
                    }
                } else {
                    if (value > props.answer.validation.max.value) {
                        invalid = props.answer.validation.max.message

                    }
                }

            }

            if (!invalid && ['country', 'nationality'].includes(props.answer.type) && value.length !== 2) {
                invalid = 'Select from one of the options'
            }

        //console.log(invalid)
        if (!invalid && [null,'',undefined].includes(value) && !props.answer?.optional){
            invalid = 'You must supply a value'
        }
        //console.log(value, invalid)
        return invalid
    }
    const handleOnFocus=(e)=> {

    }
    function getInput() {
        const smartProps = {
            setAnswer: setAnswer.bind(this),
            elementProps:{
                defaultValue: props.defaultValue,
                onFocus: handleOnFocus,
                className: props.groupState === 'invalid' ? 'is-invalid': props.groupState === 'valid' ? props?.floating ? '': 'is-valid' : ''
            },
            label: props.label,
        }
        if (!props?.editing){
            smartProps.elementProps.className += ' form-control-plaintext '
            smartProps.elementProps.readOnly = true
            smartProps.elementProps.disabled = true
        }
        if (props?.floating){
            smartProps.elementProps.placeholder = props.label
            smartProps.elementProps.className += ' font-alt text-jumbo'
        }
        if(props.expandedStyle === 'wizard'){
            smartProps.elementProps.className += ' wizard transitionable delay-2'
        }
        smartProps.expandedStyle = props.expandedStyle
        if (props.answer?.style){
            smartProps.elementProps.style = props.answer.style
        }
        if (props?.id && !props.floating){
            smartProps.elementProps.id = props.id
        }
        if (props?.suffix){
            smartProps.suffix = props.suffix
        }
        if (props?.prefix){
            smartProps.prefix = props.prefix
        }
        if (['euro','int'].includes(props.answer.type)){
            smartProps.elementProps.min = props.answer?.validation.min.value
            smartProps.elementProps.max = props.answer?.validation.max.value
        }

        if (props.answer?.suffix){
            smartProps.suffix = props.answer.suffix
        }

        switch (props.answer.type) {
            case "int":
                return <Int {...smartProps}/>
            case "agearray":
                smartProps.floating = props?.floating
                return <AgeArray key={`smartInput${props.id}`} {...smartProps}/>
            case "text":
                return <TextLine key={`smartInput${props.id}`} {...smartProps}/>
            case "float":
                return <Float key={`smartInput${props.id}`} {...smartProps}/>
            case "textarea":
                return <TextArea key={`smartInput${props.id}`} {...smartProps}/>
            case "address":
                return <Address key={`smartInput${props.id}`} {...smartProps}/>
            case "datetext":
            case "ddmmyyyy":
                return <DDMMYYYY key={`smartInput${props.id}`} {...smartProps} />
            case "mmyyyy":
                return <MMYYYY key={`smartInput${props.id}`} {...smartProps} />
            case "choice" :
                smartProps.choices = props.answer.choices
                return <Select key={`smartInput${props.id}`} {...smartProps}/>
            case "multichoice" :
                smartProps.choices = props.answer.choices
                return <MultipleChoice key={`smartInput${props.id}`} {...smartProps}/>
            case "year":
                return <Year key={`smartInput${props.id}`} {...smartProps}/>
            case "euro" :
                // console.log(props,smartProps)
                // const step= props?.step || 1
                // const min= props?.min || 1
                // const max= props?.max || 1
                // if (props?.expandedStyle){
                //     return(
                //         <NumericSlider
                //             prefix="€"
                //             step={step}
                //             min={min}
                //             max={max}
                //             label={props.label}
                //             setAnswer={smartProps.setAnswer}
                //             error={this.state.propertyValue.error}
                //             elementProps={{
                //                 defaultValue: this.state.propertyValue.defaultValue || '',
                //                 isValid: this.state.propertyValue.value && !this.state.propertyValue.error,
                //                 isInvalid: this.state.propertyValue.value && this.state.propertyValue.error,
                //             }}
                //         />
                //     )
                // }
               // console.log(smartProps.elementProps)
                return <Euro key={`smartInput${props.id}`} {...smartProps}/>
            case "country" :
                return <Countries key={`smartInput${props.id}`}   {...smartProps}/>
            case "nationality" :
                return <Countries key={`smartInput${props.id}`} nationality {...smartProps}/>
            case "phone" :
                return <Phone  key={`smartInput${props.id}`} {...smartProps}/>
            default:
                return <TextLine  key={`smartInput${props.id}`} {...smartProps}/>
        }
    }
    if (props?.floating){
        if (props.answer.type === 'agearray'){
            return getInput()
        }
        return <FloatingLabel controlId={`smartInput${props.id}`} label={props.label}>
            {getInput()}
        </FloatingLabel>
    }
    return getInput()
}
SmartInput.propTypes = {
    saveAnswer: PropTypes.func,
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object]
    ),
    name: PropTypes.string,
    hides: PropTypes.object,
    model: PropTypes.string,
    answer: PropTypes.object
};